const productTourSteps = (tabs) => [
  {
    element: '#welcome-step',
    popover: {
      className: 'first-step-popover-class',
      title: 'Welcome to the AML Calculator Demo',
      description: `
            The AML Risk Model is run on Patient Clinical attributes.
            The first step is to input any known data.
          `,
      position: 'right',
      offset: 40,
    },
  },
  {
    element: '#gender-step',
    popover: {
      title: 'Select Gender if known',
      description: `
            Every field is optional, but the model accuracy relies on more
            complete data. Select one option, as an example.
          `,
      position: 'right',
    },
  },
  {
    element: '#age-step',
    popover: {
      title: `Enter patient's age`,
      description: `
            The model accounts for certain ranges, i.e. from 0 to 120 years.
            You will get a validation error if the value it's ouside the range
          `,
      position: 'right',
    },
  },
  {
    element: '#molecular-step',
    popover: {
      title: `Enter patient's molecular results`,
      description: `
            These are classified as Genetic (SNVs or indels),
            CNA (Copy-Number Alterations), and Fusions. The input allows you to scroll
            and click to add more than 1 choices, or type a substring to search and
            filter the available choices. Type TP in Genetic to see some matches.
          `,
      position: 'right',
    },
  },
  {
    element: '#calculate-step',
    popover: {
      title: `Calculate and get the patient's risk Model`,
      description: `
            If there're not validation errors, hit the button 'Calculate' to get
            the patient risk classification and its main risk component.

            And please be patient! This can take up to 8 seconds.
          `,
      position: 'right-bottom',
    },
  },
  {
    element: '#classification-eln',
    popover: {
      title: `Wait for Classification to be returned`,
      description: `
            Current Classification based on ELN 2017 model,
            according the patient's data.
          `,
      position: 'left',
    },
  },
  {
    element: '#classification-new',
    popover: {
      title: `New Proposal Classification`,
      description: `
            New classification proposal based on Tazi et al. model,
            according the patient's data.
          `,
      position: 'left',
    },
  },
  {
    element: '#classification-component',
    popover: {
      title: `New Proposal Component`,
      description: `
            Molecular Profile that defines the Patient Clasification,
            in this new proposal.
          `,
      position: 'left',
    },
  },
  {
    element: '#cohort-distribution',
    popover: {
      title: `Patient vs Cohort`,
      description: `
        Visualize how the demographic and clinical information of the patient, when
        provided, is located relative to the AML group cohort used in the study.
      `,
      position: 'bottom',
    },
  },
  {
    element: tabs[0],
    popover: {
      title: `Patient-specific Risk Models`,
      description: `
        <i>Only active with patient data</i>
        <br/><br/>
        Graphical representation of end-point specific predictions across
        time are presented in the form of sediment and barplots.
      `,
      position: 'bottom',
    },
  },
  {
    element: tabs[1],
    popover: {
      title: `Contributing Factors`,
      description: `
        <i>Only active with patient data</i>
        <br/><br/>
        Visualize the patient specific covariates that inform each transition
        estimate alongside the corresponding coefficients.
      `,
      position: 'bottom',
    },
  },
  {
    element: tabs[2],
    popover: {
      title: `Predictions per Risk Category`,
      description: `
        Graphical representation of Tazi et al categories predictions across
        categories and components, based on cohort.
      `,
      position: 'bottom',
    },
  },
  {
    element: tabs[3],
    popover: {
      title: `Hazard Ratios`,
      description: `
        Visualize each multi-variate hazard ratio of the cohort per
        each state transition.
      `,
      position: 'bottom',
    },
  },
]

export default productTourSteps
